export const TRIMMED_PARTNER = `{
  id
  name
  display_name
  logo
  createdAt
  updatedAt
}`
